<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('actions.placeholders') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/dashboard" >{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/listOfActions" >{{ $t('actions.list_of_actions') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">{{ $t('actions.placeholders') }}</router-link>
        </li>
      </ol>
    </div>
    <SingleInvoiceRow :fetchData="fetchData" :tableDivId="tableDivId"/>
    <div class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">{{ $t('general.showing') }}: <b>{{ placeholders.length }}</b></p>
      </div>
      <table-component
        ref="table"
        :show-filter="false"
        :data="placeholders"
        table-class="table"
      >
        <table-column
          :label="$t('actions.defination')"
          show="key"
        />
        <table-column
          :label="$t('actions.value')"
          show="value"
        />
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AstronautIcon from '../../components/icon/AstronautIcon'
import SingleInvoiceRow from './SingleActionRow.vue'
export default {
  components: {
    AstronautIcon,
    SingleInvoiceRow
  },
  data () {
    return {
      advanceOption: true,
      isRequestOngoing: true,
      filtersApplied: false,
      userType: '',
      fetchData: [],
      tableDivId: 'tableDivId',
      invoiceStatus: null
    }
  },
  computed: {
    ...mapGetters('emailActionList', [
      'placeholders'
    ])
  },
  created () {
    this.loadAction()
    this.Placeholders()
  },
  methods: {
    ...mapActions('emailActionList', [
      'SingleEmailActionArray',
      'fetchEmailActionPlaceholders'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    async loadAction () {
      let response = await this.SingleEmailActionArray(this.$route.params.id)
      if (response.data) {
        this.fetchData = response.data.data
      }
    },
    async Placeholders () {
      let response = await this.fetchEmailActionPlaceholders(this.$route.params.id)
      this.isRequestOngoing = false
      return response.data
    }
  }
}
</script>
<style scoped>
#tableDivId{
  min-height: 0px;
}
</style>
